export type SumitStatus = 'imported' | 'duplicate' | 'error' | 'skipped'

const SUMIT_STATUS_COLORS: Record<SumitStatus, string> = {
  imported: 'bg-green-100 text-green-800',
  duplicate: 'bg-yellow-100 text-yellow-800',
  error:     'bg-red-100 text-red-800',
  skipped:   'bg-gray-100 text-gray-800',
}

const SUMIT_STATUS_LABELS: Record<SumitStatus, string> = {
  imported:  'Imported',
  duplicate: 'Duplicate',
  error:     'Error',
  skipped:   'Skipped',
}

interface SumitStatusBadgeProps {
  status: SumitStatus | null | undefined
  className?: string
}

export function SumitStatusBadge({ status, className = '' }: SumitStatusBadgeProps) {
  if (!status) {
    return <span className="text-gray-400">-</span>
  }

  const colorClass = SUMIT_STATUS_COLORS[status] || 'bg-gray-100 text-gray-800'
  const label = SUMIT_STATUS_LABELS[status] || status

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass} ${className}`}
      data-testid="sumit-status-badge"
      data-status={status}
    >
      {label}
    </span>
  )
}
